module.exports = __webpack_public_path__ + "img/anfahrt.27ddd75f.jpg";